import React, { useEffect, useState } from "react";
import api from "../../api/axios"; 
  

const StatCard = ({ color, icon, value, label }) => {
  return (
    <div style={{ ...styles.card, background: color.gradient }}>
      <div style={styles.cardTop}>
        <div style={styles.iconBox}>{icon}</div>
        <div>
          <h2 style={styles.value}>{value}</h2>
          <p style={styles.label}>{label}</p>
        </div>
      </div>
      <div style={styles.cardFooter}>
        <span>More info ➜</span>
      </div>
    </div>
  );
};

const DashboardSection = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardStats = async () => {
      try {
        const res = await api.get("companyblog/admin/dashboard/stats/");
        setStats(res.data);
      } catch (error) {
        console.error("Failed to load dashboard stats", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardStats();
  }, []);

  if (loading) {
  return <p>Loading dashboard...</p>;
}

if (!stats) {
  return <p>Unable to load dashboard data.</p>;
}
  return (
    <div>
      {/* Dashboard */}
      <h1 style={styles.pageTitle}>Dashboard</h1>
      <div style={styles.grid}>
        <StatCard
          color={colors.orange}
          icon="📦"
          value={stats.total_products}
          label="Total Products"
        />
        <StatCard
          color={colors.purple}
          icon="🎁"
          value={stats.total_queries}
          label="Total Queries"
        />
        <StatCard
          color={colors.cyan}
          icon="📋"
          value={stats.total_brands}
          label="Total Brands"
        />
        <StatCard
          color={colors.blue}
          icon="👥"
          value={stats.total_users}
          label="Total Users"
        />
        <StatCard
          color={colors.red}
          icon="🎞️"
          value={stats.total_sliders}
          label="Sliders"
        />
        <StatCard
          color={colors.lightBlue}
          icon="🏪"
          value={stats.total_dealers}
          label="Dealers"
        />
        <StatCard
          color={colors.teal}
          icon="💬"
          value={stats.total_testimonials}
          label="Testimonials"
        />
        <StatCard
          color={colors.green}
          icon="🗂️"
          value={stats.total_categories}
          label="Category"
        />
        <StatCard
          color={colors.purple}
          icon="📤"
          value={stats.total_files}
          label="Files"
        />
      </div>

      {/* Maintenance Records */}
      <h2 style={styles.sectionTitle}>Maintenance Records</h2>
      <div style={styles.grid}>
        <StatCard
          color={colors.teal}
          icon="⚙️"
          value={stats.maintenance_delivered}
          label="Delivered"
        />
        <StatCard
          color={colors.blue}
          icon="⚙️"
          value={stats.maintenance_parts_pending}
          label="Parts Pending"
        />
        <StatCard
          color={colors.orange}
          icon="⚙️"
          value={stats.maintenance_pending}
          label="Pending"
        />
        <StatCard
          color={colors.green}
          icon="⚙️"
          value={stats.maintenance_resolved}
          label="Resolved Problem"
        />
        <StatCard
          color={colors.red}
          icon="⚙️"
          value={stats.maintenance_unable_to_repair}
          label="Unable To Repair"
        />
        <StatCard
          color={colors.dark}
          icon="⚙️"
          value={stats.maintenance_warranty}
          label="Warranty"
        />
      </div>
    </div>
  );
};
const colors = {
  orange: { gradient: "linear-gradient(135deg,#ff9800,#f57c00)" },
  purple: { gradient: "linear-gradient(135deg,#7e57c2,#5e35b1)" },
  cyan: { gradient: "linear-gradient(135deg,#26c6da,#0097a7)" },
  blue: { gradient: "linear-gradient(135deg,#42a5f5,#1e88e5)" },
  green: { gradient: "linear-gradient(135deg,#43a047,#2e7d32)" },
  red: { gradient: "linear-gradient(135deg,#e53935,#b71c1c)" },
  lightBlue: { gradient: "linear-gradient(135deg,#bbdefb,#90caf9)" },
  teal: { gradient: "linear-gradient(135deg,#00acc1,#00838f)" },
  dark: { gradient: "linear-gradient(135deg,#424242,#212121)" },
};

const styles = {
  pageTitle: {
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "20px",
  },
  sectionTitle: {
    marginTop: "35px",
    marginBottom: "15px",
    fontSize: "22px",
    fontWeight: "500",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
    gap: "20px",
  },
  card: {
    borderRadius: "8px",
    color: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    overflow: "hidden",
  },
  cardTop: {
    display: "flex",
    alignItems: "center",
    padding: "20px",
    gap: "15px",
  },
  iconBox: {
    width: "52px",
    height: "52px",
    backgroundColor: "rgba(0,0,0,0.25)",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "22px",
  },
  value: {
    margin: 0,
    fontSize: "30px",
    fontWeight: "700",
  },
  label: {
    margin: 0,
    fontSize: "15px",
  },
  cardFooter: {
    background: "rgba(0,0,0,0.15)",
    padding: "10px 20px",
    fontSize: "14px",
    cursor: "pointer",
  },
};

export default DashboardSection;
